// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1IRS4","ModalHeader":"Modal_ModalHeader__1mOcs"};